import { useQuery } from "@tanstack/react-query";
import { albumSummary } from "@/api/admits-seva-album";

/** "Rohit and Meera, your matches, added 14": the server's count for this reader. */
export function AlbumFromMatches({ eventId }: { eventId: string }) {
  const { data } = useQuery({ queryKey: ["album-summary", eventId], queryFn: () => albumSummary(eventId) });
  if (!data) return null;
  return (
    <p className="text-xs text-gray-600">
      {data.photos} photos, {data.videos} videos from {data.contributors} people
      {data.fromMatches !== null &&
        ` · your matches who went added ${data.fromMatches}` +
          (data.matchesWhoAdded.length ? ` (${data.matchesWhoAdded.map((m) => m.name).join(", ")})` : "")}
    </p>
  );
}
